import { Account, UserAccount } from "@src/@types/UserAccount";
import axiosInstance from "@src/configs/axiosConfig";
import {
  handleSetOnLoading,
  handleUserAccount,
} from "@src/redux/reducers/userAccount";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/redux";

export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";

function useFetchData() {
  const dispatch = useDispatch();
  const activeAccount = useSelector<RootState, Account | undefined>(
    (state) => state.userAccount.activeAccount
  );
  const fetchUserAccountData = () => {
    console.log("start");
    axiosInstance
      .get("/user")
      .then((response) => {
        let userAccount: UserAccount = response.data;
        console.log("user back");
        console.log(userAccount);
        dispatch(handleUserAccount(userAccount));
        dispatch(handleSetOnLoading(false));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };

  /***
   *  Obtém o código passando a string do site.
   * @param site string do domínio
   * @param Function setter do código de instalação.
   * */
  const fetchCode = async (site: string, setCode: Function) => {
    let custom = '';
    await axiosInstance
      .get(`/widget/${site}`)
      .then((response) => {
        const { data } = response;
        const mobile = { ...data.mobile };
        delete data.mobile;
        const code = { ...data, mobile };
        const customCode = `
        <script onload="assistive.init(
          ${JSON.stringify(code, null, 4)}
        )" src="https://cdn.assistive.com.br/plugin/AssistiveWebPlugin_staging.js" charset="UTF-8" type="text/javascript" async="true" astvAccountId="${activeAccount?.astvId ?? ''}"></script>
        `;
        dispatch(handleSetOnLoading(false));
        setCode(customCode);
        console.log(customCode);
        custom = customCode;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {return ''});

      return custom;

  };

  return { fetchUserAccountData, fetchCode };
}

export default useFetchData;
